import React from "react";
import {
  Drawer,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  Switch,
  Typography,
  Box,
  Divider,
  IconButton,
} from "@material-ui/core";
import {
  ClipboardList,
  Calculator,
  FileText,
  DollarSign,
  CloudSun,
  X,
} from "lucide-react";
import { useWidgetStore } from "../../store/widgetStore";

const widgetsConfig = [
  {
    id: "calculator",
    label: "Calculadora",
    description: "Realize contas e cálculos rápidos",
    icon: <Calculator style={{ color: "#1976d2" }} size={22} />,
  },
  {
    id: "notepad",
    label: "Bloco de Notas",
    description: "Anote lembretes e rascunhos",
    icon: <FileText style={{ color: "#ed6c02" }} size={22} />,
  },
  {
    id: "dollar",
    label: "Cotação do Dólar / Euro",
    description: "Acompanhe moedas em tempo real",
    icon: <DollarSign style={{ color: "#2e7d32" }} size={22} />,
  },
  {
    id: "weather",
    label: "Previsão do Tempo",
    description: "Verifique o clima da sua cidade",
    icon: <CloudSun style={{ color: "#f57c00" }} size={22} />,
  },
];

const ClipboardDrawer = ({ open, onClose }) => {
  const { activeWidgets, toggleWidget } = useWidgetStore();

  return (
    <Drawer anchor="right" open={open} onClose={onClose}>
      <Box
        style={{
          width: 340,
          padding: 20,
          height: "100%",
          backgroundColor: "#f4f6f8",
          boxSizing: "border-box",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* Header do Drawer */}
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          marginBottom={2}
        >
          <Box display="flex" alignItems="center">
            <ClipboardList style={{ color: "#3f51b5", marginRight: 10 }} size={28} />
            <Typography variant="h6" style={{ fontWeight: "bold", color: "#333" }}>
              Minha Prancheta
            </Typography>
          </Box>
          <IconButton onClick={onClose} size="small">
            <X size={20} />
          </IconButton>
        </Box>

        <Typography variant="body2" style={{ color: "#666", marginBottom: 16 }}>
          Ative os utilitários abaixo para exibi-los flutuando sobre o sistema.
        </Typography>

        <Divider style={{ marginBottom: 16 }} />

        {/* Lista de Widgets */}
        <List style={{ backgroundColor: "#ffffff", borderRadius: 10, boxShadow: "0 1px 4px rgba(0,0,0,0.08)" }}>
          {widgetsConfig.map((widget, index) => (
            <React.Fragment key={widget.id}>
              {index > 0 && <Divider component="li" />}
              <ListItem style={{ padding: "12px 16px" }}>
                <Box style={{ marginRight: 14, display: "flex", alignItems: "center" }}>
                  {widget.icon}
                </Box>
                <ListItemText
                  primary={widget.label}
                  secondary={widget.description}
                  primaryTypographyProps={{ style: { fontWeight: "bold", fontSize: "0.9rem" } }}
                  secondaryTypographyProps={{ style: { fontSize: "0.75rem" } }}
                />
                <ListItemSecondaryAction style={{ right: 12 }}>
                  <Switch
                    edge="end"
                    color="primary"
                    checked={Boolean(activeWidgets[widget.id])}
                    onChange={() => toggleWidget(widget.id)}
                  />
                </ListItemSecondaryAction>
              </ListItem>
            </React.Fragment>
          ))}
        </List>

        <Box marginTop="auto" paddingTop={2} textAlign="center">
          <Typography variant="caption" style={{ color: "#999" }}>
            Você pode arrastar e redimensionar os widgets ativos livremente na tela.
          </Typography>
        </Box>
      </Box>
    </Drawer>
  );
};

export default ClipboardDrawer;
